import { render } from "./LoginInd.vue?vue&type=template&id=2384ed04"
import script from "./LoginInd.vue?vue&type=script&lang=js"
export * from "./LoginInd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/Downloads/_TRASH/loyalty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__